import React from 'react';
import ReactDOM from 'react-dom';
import { Dialog, Toolbar, IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

// Reusable in-app PDF viewer: an MUI Dialog with a native <iframe> (browsers render
// PDFs inline — no external SDK/library). Shown imperatively via showPdf(url, name)
// so the manufacturing tabs keep calling openDoc() unchanged.
function PdfViewerModal({ url, name, onClose }) {
  const download = () => {
    const a = document.createElement('a');
    a.href = url; a.download = name || 'document.pdf';
    document.body.appendChild(a); a.click(); a.remove();
  };
  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{ style: { height: '92vh', display: 'flex', flexDirection: 'column' } }}
    >
      <Toolbar
        variant="dense"
        style={{ justifyContent: 'space-between', background: '#f5f5f5', borderBottom: '1px solid #e0e0e0', minHeight: 44 }}
      >
        <Typography variant="subtitle2" noWrap style={{ maxWidth: '70%', color: '#333' }} title={name}>
          {name}
        </Typography>
        <span style={{ whiteSpace: 'nowrap' }}>
          <IconButton size="small" title="Open in new tab" onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}>
            <OpenInNewIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" title="Download" onClick={download}>
            <GetAppIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" title="Close" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </span>
      </Toolbar>
      <iframe
        src={url}
        title={name || 'PDF'}
        style={{ border: 'none', width: '100%', flex: 1 }}
      />
    </Dialog>
  );
}

// Singleton mount so any caller can show a PDF without wiring modal state per component.
let _node = null;
export function showPdf(url, name) {
  if (!url) return;
  if (!_node) { _node = document.createElement('div'); document.body.appendChild(_node); }
  const close = () => ReactDOM.unmountComponentAtNode(_node);
  ReactDOM.render(<PdfViewerModal url={url} name={name} onClose={close} />, _node);
}

export default PdfViewerModal;
